import { type CommandProperties, createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Data payload for creating a Confluence space.
 */
type ConfluenceCreateSpaceData = {
	/**
	 * The string representation of a space
	 */
	jsonSpace: string;
};

/**
 * Properties for the Confluence space creation command.
 *
 * @extends CommandProperties
 */
export interface ConfluenceCreateSpaceCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the space creation request.
	 */
	key: string;
	/**
	 * The data payload containing the content for the new space.
	 */
	data: ConfluenceCreateSpaceData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
}
/**
 * A command sent by a bridge API client to create a new Confluence space.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Confluence space with the specified content.
 */
export const ConfluenceSpaceCreateCommand = createCommand<ConfluenceCreateSpaceCommandProperties>(
	'confluence-space-create-command',
);
